module.exports = __webpack_public_path__ + "685629ebaff15bb68b66cfcc3535d4d2.svg";